export default "__VITE_ASSET__Dz8A3HtG__"